import {NavigationItemRaw} from '@/navigation/interface'

const user: NavigationItemRaw[] = [{
    id: 2,
    right: true,
    subject: 'admin.user.index',
    route: 'AdminUser',
    icon: 'user',
    children: [],
    attached: [
        'AdminUserCreate',
        'AdminUserEdit',
    ]
}]

export default user
